module.exports = "<p>\n  calcfunctions works!\n</p>\n"